export const META_TAG = {
  MONS_WEBLAB: 'a2z:mons_weblab_treatment', // https://w.amazon.com/bin/view/Mons/Weblab/Configuration
  CSRF_TOKEN: 'anti-csrftoken-a2z', // CSRF token meta tag name for Mons system
};
